import { useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import { fakeRecommendedGroupClassInstance } from "@/__mocks__/recommendedGroupClass";
import type { RecommendedGroupClassInstance } from "@/store/api/schedule/groupClasses";
import type { TimeSlotSelectorProps } from "@/ui/components/groupClasses/series/TimeSlotSelector";
import TimeSlotSelector from "@/ui/components/groupClasses/series/TimeSlotSelector";
import { Box } from "@/ui/layout";

const instances: RecommendedGroupClassInstance[] = [
  fakeRecommendedGroupClassInstance(),
  fakeRecommendedGroupClassInstance(),
  fakeRecommendedGroupClassInstance(),
];

const StoryMeta: Meta<TimeSlotSelectorProps> = {
  title: "Components/GroupClasses/Series/Time Slot Selector",
  component: TimeSlotSelector,
  decorators: [
    (Story) => (
      <Box width="100%">
        <Story />
      </Box>
    ),
  ],
  argTypes: {
    onSelect: { action: "selected" },
    testID: { control: "text" },
  },
  args: {
    instances,
    testID: "storybook",
  },
};

type Story = StoryObj<TimeSlotSelectorProps>;

const Primary: Story = {};

const WithSelection: Story = {
  args: {
    selectedInstanceId: "gc_67890",
  },
};

const InteractiveRender = () => {
  const [selectedId, setSelectedId] = useState<string>(
    instances[0].groupClassExternalId,
  );

  return (
    <TimeSlotSelector
      instances={instances}
      onSelect={setSelectedId}
      selectedInstanceId={selectedId}
      testID="storybook"
    />
  );
};

const Interactive: Story = {
  render: InteractiveRender,
};

export { Interactive, Primary, WithSelection };
export default StoryMeta;
